<template>
    <span :class="[num >= 0 ? 'red' : 'green']"> {{ c_num }}{{ unit }} </span>
</template>


<script>
export default {
    name: "mark-num",
    props: {
        num: {
            type: Number,
        },
        unitType: {
            type: String,
        },
        floatPlaceNum: {
            type: Number,
            default: 2,
        },
        isAbs: {
            type: Boolean,
            default: false,
        },
        isCalUnit: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            c_num: this.num,
            unit: "",
            yi: 100000000,
            wan: 10000,
        };
    },
    mounted() {
        this.formatterNum();
    },
    methods: {
        formatterNum() {
            console.log(this.num, this.unitType);
            if (this.num != undefined) {
                let c_num = this.c_num;
                if (this.isCalUnit) {
                    if (Math.abs(this.num) >= this.yi) {
                        c_num = c_num / this.yi;
                        if (this.unitType == "STOCK") {
                            this.unit = "亿股";
                        } else {
                            this.unit = "亿元";
                        }
                    } else if (Math.abs(this.num) >= this.wan) {
                        c_num = c_num / this.wan;
                        if (this.unitType == "STOCK") {
                            this.unit = "万股";
                        } else {
                            this.unit = "万元";
                        }
                    } else if (Math.abs(this.num) < this.wan) {
                        if (this.unitType == "STOCK") {
                            this.unit = "股";
                        } else {
                            this.unit = "元";
                        }
                    }
                    if (this.isAbs) {
                        c_num = Math.abs(c_num);
                    }
                    this.c_num = c_num.toFixed(this.floatPlaceNum, 10);
                } else {
                    this.unit = this.unitType;
                    if (this.isAbs) {
                        c_num = Math.abs(c_num);
                    }
                    this.c_num = c_num.toFixed(this.floatPlaceNum, 10);
                }
            } else {
                return "";
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.red {
    color: #ff3333;
}
.green {
    color: #60c417;
}
</style>

